/**
 * DataZone — TELV1-296 UX commit 6: narrowed to Themes & Opportunities only.
 *
 * Categories was extracted into its own CategoriesZone (rendered higher
 * up, directly below Summary) per QA feedback. This zone now hosts only
 * the legacy themes_and_opportunities block, which is still useful as a
 * "deeper synthesis" surface below the raw answers and evidence — same
 * position as before, just without Categories sharing the container.
 *
 * The block only renders when `patterns_and_trends` is absent (legacy
 * schema fallback) and there is at least one theme or opportunity to
 * show — otherwise the whole zone collapses.
 */
import { Lightbulb } from 'lucide-react';
import ProjectQuestionInsights from '../ProjectQuestionInsights';
import { resolveTranslation } from '@/utils/resolveTranslation';
import { translateThemesAndOpportunities } from '@/pages/projects/single-project/Content/project_results/resultsPageTranslations';
import type { InsightsSubset } from '@/types';

interface DataZoneProps {
  insights?: InsightsSubset;
  isLoading: boolean;
  analysisLanguage: string;
}

function DataZone({ insights, isLoading, analysisLanguage }: DataZoneProps) {
  // Show legacy themes + opportunities only when new-schema patterns_and_trends is absent
  const consolidated = !insights?.patterns_and_trends?.length
    ? [...(insights?.themes || []), ...(insights?.opportunities || [])]
    : [];

  if (consolidated.length === 0) return null;

  return (
    <div className="flex flex-col gap-5 rounded-xl bg-neutral-50/50 p-5 -mx-1">
      <ProjectQuestionInsights
        data={consolidated}
        title={resolveTranslation(translateThemesAndOpportunities, analysisLanguage)}
        isLoading={isLoading}
        noDataText=""
        icon={<Lightbulb className="h-5 w-5 text-secondary" />}
      />
    </div>
  );
}

export default DataZone;
